import "./App.css";
import Search from "./Search";
import { useEffect, useState } from "react";
import Result from "./Result";
import Details from "./Details";
// import {  Routes, Route, Link } from 'react-router-dom';
function Home() {
  const [search, setSearch] = useState("");
  const [apiData, setApiData] = useState([]);
  const [IMDB, setIMDB] = useState("");

  useEffect(() => {}, [search]);

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const renderMovies = () => {
    let updatedSearch = search.replace(/\s+/g, "+");
    fetch(`https://www.omdbapi.com/?apikey=8aabe4c8&s=${updatedSearch}`)
      .then((response) => response.json())
      .then((data) => {
        setApiData(data);
        console.log(data);
      });
  };

 

  return (

    <div className="App">
      <Search
        searchValue={search}
        handleSearch={handleSearch}
        renderMovies={renderMovies}
      ></Search>
      {apiData.Search ? (
        <Result
          searchValue={search}
          data={apiData}
        ></Result>
      ) : null}
      
    </div>
  );
}

export default Home;
